








































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
@Component
export default class ECSettingView extends Vue {
  public items: Common.ECSetting[] = new Array(0);
  public params: Common.ECSettingQuery = new Common.ECSettingQuery();

  public sortOptions: any = [
    { value: 'ecFlag', text:'EC連携先' },
  ];

  public created() {
    if ((this.$route.query.code || this.$route.query.spapi_oauth_code) && this.$route.query.state){
       //stateパラメータの2つ目をとる
        const ecFlag = Number.parseInt((this.$route.query.state as string).split('|')[1]);
        const seqNo = Number.parseInt((this.$route.query.state as string).split('|')[2]);
        const codeVerifier = (this.$route.query.state as string).split('|')[3];
        // Amazonの場合、セラーIDをパラメータから取得して保存
        var sellingPartnerId:string = "";
        if(ecFlag == Common.ECFlags.Amazon)
        {
           sellingPartnerId = this.$route.query.selling_partner_id as string;
        }
        this.$api.execute(new Common.ECApiAuthorizeQuery((this.$route.query.code ?? this.$route.query.spapi_oauth_code) as string,ecFlag,seqNo,codeVerifier, sellingPartnerId)).then(res => {
          // ブラウザの戻るボタンや認証切れの際の再ログインの際に、クエリパラメータありのURLに飛ばされると400エラーが出るため、history.replaceStateを使用して履歴を書き換える
          const cleanPath = this.$route.path;
          history.replaceState(null, '', cleanPath);
          this.$router.push(cleanPath, () => {
            this.$api.modal.showDialog('メッセージ','ECサイトでの認証が完了しました。').then(() => {
              var index = this.items.findIndex(obj => obj.ecFlag == ecFlag);
              this.$set(this.items, index, res);
              (this.$refs.mainList as Components.ListView).listSelect(index, true);
            });
          });
        });
    }
  }

  public async onCreate(obj: Common.ECSetting) {
    const workflows = this.$api.formatter.getOptions('workflow_approval');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  //暫定実装～リダイレクト先で実装する必要がある
  public async onAuthorize(item:Common.ECSetting){
    if(item.ecFlag == Common.ECFlags.Amazon){
      // ※開発中はversion=betaを指定。公開後は取り外し可
      const authUrl = "https://sellercentral.amazon.com/apps/authorize/consent?application_id={0}&redirect_uri={1}&state={2}&version=beta";
      const state = this.$api.license.tenantId + '|' + Common.ECFlags.Amazon.toString() + '|' + item.seqNo.toString();
      var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
      redirect_uri += location.pathname;
      if(this.$api.enviromentFlag == Common.enviromentFlags.develop) redirect_uri="https://teams.code-x.co.jp/system/ECSetting"; // 開発環境用、localhostがリダイレクトURIに指定できなかったため回避用
      var query = new Common.GetAmazonApplicationIdQuery();
      this.$api.execute(query).then(rtn => {
        const client_id = rtn;
        var ut =String.format(authUrl,client_id,redirect_uri,state);
        location.href = encodeURI(String.format(authUrl,client_id,encodeURIComponent(redirect_uri),state));
      });

    }
    else if (item.ecFlag == Common.ECFlags.Base){
      const url = 'https://api.thebase.in/1/oauth/authorize?response_type=code&client_id={0}&redirect_uri={1}&state={2}&scope=read_items read_orders write_items';
      var query = new Common.GetBaseClientIdQuery();
      this.$api.execute(query).then(rtn => {
        const client_id = rtn;//'3948bff61d960d0e0261e84dc371d861'; 
        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;
        const state = this.$api.license.tenantId + '|' + Common.ECFlags.Base.toString() + '|' + item.seqNo.toString();
        location.href = encodeURI(String.format(url,client_id,redirect_uri,state));
      });
    }
    else if (item.ecFlag == Common.ECFlags.Smaregi){
      let codeVerifier = [...crypto.getRandomValues(new Uint8Array(32))]
          .map(b => b.toString(36).padStart(2, '0')) // Base36でエンコード
          .join('')
          .slice(0, 43); // 43文字に調整
      // code_challengeを計算
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      // Base64 URL セーフに変換
      const code_verifier_hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)))
        .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

      var url = this.$api.enviromentFlag == Common.enviromentFlags.production ? "https://id.smaregi.jp" : "https://id.smaregi.dev";
      url += '/authorize?response_type=code&client_id={0}&scope=openid offline_access&state={1}&redirect_uri={2}&code_challenge={3}&code_challenge_method=S256';
      var query = new Common.GetSmaregiClientIdQuery();
      this.$api.execute(query).then(rtn => {
        const client_id = rtn;
        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;
        const state = this.$api.license.tenantId + '|' + Common.ECFlags.Smaregi.toString() + '|' + item.seqNo.toString()+ '|' + codeVerifier;
        location.href = encodeURI(String.format(url,client_id,state,redirect_uri,code_verifier_hash));
      });
    }
    else if (item.ecFlag == Common.ECFlags.Bcart){
       let codeVerifier = [...crypto.getRandomValues(new Uint8Array(32))]
          .map(b => b.toString(36).padStart(2, '0')) // Base36でエンコード
          .join('')
          .slice(0, 43); // 43文字に調整
      const url = 'https://app.bcart.jp/oauth/authorize?client_id={0}&response_type=code&redirect_uri={1}&scope={2}&state={3}';
      const scopeList = [
        "products-read",
        "product_sets-read",
        "product_stock-read",
        "product_stock-write",
        "orders-read",
        "logistics-read",
      ];
      var query = new Common.GetBcartClientIdQuery();
      this.$api.execute(query).then(rtn => {
        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;
        const client_id = rtn;
        const scope = scopeList.join(' ');
        const state = this.$api.license.tenantId + '|' + Common.ECFlags.Bcart.toString() + '|' + item.seqNo.toString()+ '|' + codeVerifier;
        location.href = encodeURI(String.format(url,client_id,redirect_uri,scope,state));
      })
    }
    else if (item.ecFlag == Common.ECFlags.Yahoo){
       let codeVerifier = [...crypto.getRandomValues(new Uint8Array(32))]
          .map(b => b.toString(36).padStart(2, '0')) // Base36でエンコード
          .join('')
          .slice(0, 43); // 43文字に調整
      var url = 'https://auth.login.yahoo.co.jp/yconnect/v2/authorization?response_type=code&client_id={0}&redirect_uri={1}&scope={2}&bail=1&state={3}';
      const scopeList = [
        "openid",
        "profile",
      ];
      var query = new Common.GetYahooClientIdQuery();
      this.$api.execute(query).then(rtn => {
        var redirect_uri =  location.origin.toLowerCase().replace(this.$api.license.tenantId.toLowerCase(), "login");
        redirect_uri += location.pathname;
        const client_id = rtn;
        const scope = scopeList.join('+');
        const state = this.$api.license.tenantId + '|' + Common.ECFlags.Yahoo.toString() + '|' + item.seqNo.toString()+ '|' + codeVerifier;
        location.href = encodeURI(String.format(url,client_id,redirect_uri,scope,state));
      })
    }
    // this.$api.execute(new Common.ECAuthorizeQuery('7c480ac2e39adb9a68d2b8b46c60f44a',null)).then(res => this.$set(this.items, (this.$refs.mainList as Components.ListView).selectedId(),res));
  }


  public checkSelectedItems():boolean{
    var selectedItems = (this.$refs.mainList as Components.ListView).selectedItems as Array<Common.ECSetting>;
    if (selectedItems == null || selectedItems.length == 0) {
      this.$api.modal.show('無効な操作', '対象となる項目を選択して下さい。', true, null);      
      return false;
    }
    if (selectedItems.filter(obj =>obj.state == Common.ApprovalStatus.NotApproved).length != 0) {
      this.$api.modal.show('無効な操作', '「公開待ち」の項目に対しては処理を実行できません。', true, null);      
      return false;
    }
    if (selectedItems.filter(obj =>obj.hasValidToken == false).length != 0) {
      this.$api.modal.show('無効な操作', '「認証待ち」の項目に対しては処理を実行できません。', true, null);      
      return false;
    }    
    return true;
  }
  public execCommodityQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','商品取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECCommodityQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','商品取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });
    }
  }

  public execOrderQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','注文取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECOrderQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','注文取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });
    }
  }
  public execProcessQuery(){
    if (this.checkSelectedItems()){
      this.$api.modal.showDialog('メッセージ','出荷取込処理を開始してよろしいですか？',false).then(()=>{
        this.$api.execute(new Common.ECProcessQuery((this.$refs.mainList as Components.ListView).selectedItems)).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','出荷取込処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);       
        });
      });        
    }    
  }
    public onEcOptionFlagsChanged(item:Common.ECSetting) {
      if(item.ecOptionFlag == Common.ECOptionFlags.Base_UseIdentifier ) item.autoCommodityInsert2 = false;
  }  
}
